var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"docContainer","element-loading-text":"文档加载中...","element-loading-background":"rgba(0, 0, 0, 0.5)"}},[_c('iframe',{ref:"iframeID"}),(_vm.docloaded)?_c('application',{ref:"docApplication",attrs:{"type":"pdf"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }